/* eslint-disable react/prop-types */
import React from 'react';
import './Loader.scss';

const Loader = () => (
    <div className="loader">
        <div className="r1" />
        <div className="r2" />
        <div className="r3" />
        <div className="r4" />
        <div className="r5" />
    </div>
);
export default Loader;
